import { InjectionToken, signal, ViewContainerRef } from '@angular/core';

export interface LoadingSpinnerWrapperService {
  attach?: (viewContainerRef: ViewContainerRef) => void;
  show: () => void;
  hide: () => void;
  showSpinner: () => void;
  hideSpinner: () => void;
}

export const LOADING_SPINNER_SERVICE_TOKEN =
  new InjectionToken<LoadingSpinnerWrapperService>(
    'LoadingSpinnerWrapperService'
  );

export abstract class LoadingSpinnerBaseService
  implements LoadingSpinnerWrapperService
{
  readonly count = signal(0);
  readonly keydownEvent = 'keydown';
  readonly preventDefault = (e: Event) => {
    e.preventDefault();
  };

  abstract show(): void;
  abstract hide(): void;

  /**
   * Spinnerをshowする
   */
  showSpinner(): void {
    if (this.count() === 0) {
      this.show();
      // API複数実行等を避けるため、キー押下イベントを受け付けないようにする
      document.addEventListener(this.keydownEvent, this.preventDefault);
    }
    this.count.update((value) => value + 1);
  }

  /**
   * Spinnerをhideする
   */
  hideSpinner(): void {
    this.count.update((value) => value - 1);
    if (this.count() === 0) {
      this.hide();
      document.removeEventListener(this.keydownEvent, this.preventDefault);
    }
  }
}
